<!-- 应用场景 -->
<template>
  <div class="appSen">
    <h3 class="h3">应用场景</h3>
    <div class="appSenCon width">
      <ul>
        <li
          :class="indexs==i?'active':''"
          @click="handle(i)"
          v-for="(item,i) in listTitle"
          :key="i"
        >{{item.title}}</li>
      </ul>
      <div class="appContent">
        <div class="appItem" v-for="(items,is) in listData" :key="is">
          <template v-if="show">
            <div class="appItemText">
              <div class="textItem" v-for="(item1,i1) in listData[is].child" :key="i1">
                <i></i>
                <h4>{{item1.title}}</h4>
                <p>{{item1.content}}</p>
              </div>
            </div>
            <div class="appItemImg">
              <img :src="items.icon" alt srcset />
            </div>
          </template>
        </div>

        <div class="appItem" v-for="(item,i) in listData1" :key="i">
          <template v-if="show1">
            <div class="appItemImg">
              <img :src="item.icon" alt srcset />
            </div>
            <div class="appItemText">
              <div class="textItem" v-for="(item1,i1) in listData1[i].child" :key="i1">
                <i></i>
                <h4>{{item1.title}}</h4>
                <p>{{item1.content}}</p>
              </div>
            </div>
          </template>
        </div>

        <template>
          <div class="appItem" v-if="show2">
            <div class="appItemCon">
              <div class="itemApp" v-for="(item,i) in listData2" :key="i">
                <h3>{{item.title}}</h3>
                <div class="imgs">
                  <img v-for="(item1,i1) in item.child" :key="i1" :src="item1.imgs" alt srcset />
                </div>
              </div>
            </div>
          </div>
        </template>
        <template>
          <div class="appItem" v-if="show3">
            <div class="appItemList">
              <div class="appItemListItem" v-for="(item,i) in listData3" :key="i">
                <p>{{item.title}}</p>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {
      indexs: 0,
      show: true,
      show1: false,
      show2: false,
      show3: false,
      listTitle: [
        { id: 1, title: '设备资产管理' },
        { id: 2, title: '设备在线监控' },
        { id: 3, title: '设备数据采集' },
        { id: 4, title: '生产数据采集' },
      ],
      listData: [
        {
          id: 0,
          icon: require('../assets/images/u1818.png'),
          child: [
            {
              title: '全生命周期管理',
              content:
                '从固定资产采购，至验收入库、领用归还、转移调拨、巡检维修、报废处置等的全周期精益管理',
            },
            {
              title: '极速盘点',
              content: '系统自定义设备唯一吗，移动设备扫码盘点，更加方便快捷',
            },
            {
              title: '工单维修',
              content:
                '借助实时流转的工单，和及时的提醒、通知，资产维修、巡检等工作被有效组织，实现多角色间的高效协同',
            },
            {
              title: '账实统一',
              content:
                '资产台账与企业财务系统记账实时对接，折旧、增减值等实时互通，彻底解决账实不符。',
            },
            {
              title: '计划性维护',
              content:
                '资产预防性维护计划编排一览无余，自动触发工单执行，让所有工作有条不紊。',
            },
            {
              title: '资产效益分析',
              content:
                '资产效益分析模型能够及时探知资产闲置情况，加快资产调拨流转，促进资产合理配置，充分发挥既有财产使用价值，有效避免资产重复采购。',
            },
            {
              title: '多终端集成',
              content:
                '提供Web、App、小程序、H5（可接入企业微信、钉钉或企业内部应用等）多种终端入口。',
            },
          ],
        },
      ],
      listData1: [
        {
          id: 1,
          icon: require('../assets/images/u1824.png'),
          child: [
            {
              title: '实时运行监测',
              content:
                '实时运行监测页面与首页的实时监测页面相同，将设备模型与实时数据结合，用户可直观了解设备整体的运行情况。设备关键参数与报警信息，实时展示在模型中。',
            },
            {
              title: '设备运行报表',
              content:
                '设备运行报表通过关键参数指标计算，得出设备运行时长、设备开机率、OEE等设备运行指标。不仅提供了设备的整体运行信息（包括运行时长、停运时长、开机率、运行状态图等），而且提供了设备属性在不同时间段的实时数据。针对设备的整体信息，提供了运行时长和停运时长的柱状图，方便用户直观比较设备的运行情况。',
            },
            {
              title: '直观数据展示',
              content:
                '针对单一设备的属性数据信息，不仅提供了属性在不同时间的折线图，而且还有针对属性的异常预警散点图，基于算法分析设备运行指标，自动识别异常数据，将异常点绘制在报表中。不仅可以辅助技术人员评估设备运行状态，而且为维保人员保养提供数据支持。',
            },
            {
              title: '设备运行详情',
              content:
                '设备运行详情专注于某一设备的属性的数据变化。不仅可以展示同一设备的不同属性的数据情况，在同一个折线图中完全展示，而且还可以专注于单一设备的单一属性。设备运行详情报表通过列表、折线图、异常预警散点图等展现方式从不同方面展示设备属性的数值变化。',
            },
          ],
        },
      ],
      listData2: [
        {
          title: '生产设备',
          child: [
            { imgs: require('../assets/images/u1831.png') },
            { imgs: require('../assets/images/u1832.png') },
            { imgs: require('../assets/images/u1834.png') },
            { imgs: require('../assets/images/u1836.png') },
          ],
        },
        {
          title: '采集设备',
          child: [{ imgs: require('../assets/images/u1841.png') }],
        },
        {
          title: '网络环境',
          child: [{ imgs: require('../assets/images/u1842.png') }],
        },
        {
          title: '设备特点',
          child: [{ imgs: require('../assets/images/u1845.png') }],
        },
      ],
      listData3: [
        {
          title: '员工刷卡登录、刷卡上下机、刷卡确认功能。',
        },
        {
          title: '通过数据采集硬件对设备参数进行采集。',
        },
        {
          title:
            '帮助企业建模，对产品数据、工艺数据、基础数据、报警配置、资源数据、系统配置进行管理。',
        },
        {
          title: '支持计划分解、排程和管理功能。',
        },
        {
          title: '对生产过程、工单过程进行监控。',
        },
        {
          title:
            '质量管理包含首件检验、过程检验、出货检验、分拣管理和不良品录入。',
        },
        {
          title: '设备管理包含设备和模具点检、维保和计量管理。',
        },
        {
          title: '报表管理包含业务报表和看板展示。',
        },
        {
          title: '库存管理包含原来仓管理、投料管理、成品库管理。',
        },
      ],
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handle(i) {
      this.indexs = i
      switch (i) {
        case 0:
          this.show = true
          this.show1 = false
          this.show2 = false
          this.show3 = false
          break
        case 1:
          this.show = false
          this.show1 = true
          this.show2 = false
          this.show3 = false
          break
        case 2:
          this.show = false
          this.show1 = false
          this.show2 = true
          this.show3 = false
          break
        case 3:
          this.show = false
          this.show1 = false
          this.show2 = false
          this.show3 = true
          break
        default:
          //这里是没有找到对应的值处理
          break
      }
    },
  },
}
</script>

<style lang="less" scoped>
.appSen {
  width: 100%;
  padding-bottom: 40px;
  margin-bottom: 10px;
  padding-top: 20px;
  margin-top: 10px;
  background: url('../assets/images/u213.png') 100% 100% no-repeat;
  background-size: cover;
  .h3 {
    width: 140px;
    height: 25px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    text-align: center;
    padding-bottom: 10px;
    color: #fff;
    border-bottom: 2px solid #0078d7;
    margin: 0 auto 20px auto;
  }
  .appSenCon {
    ul {
      width: 520px;
      display: flex;
      color: #fff;
      margin: 0 auto 0 auto;
      li {
        flex: 1;
        text-align: center;
        font-size: 16px;
        line-height: 60px;
        cursor: pointer;
      }
      .active {
        color: #0078d7;
        border-top: 3px solid #0078d7;
      }
    }
    .appContent {
      .appItem {
        display: flex;
        background-color: #fff;
        .appItemText {
          flex: 1;
          margin-left: 20px;
          .textItem {
            position: relative;
            margin-bottom: 20px;
            padding-left: 30px;
            i {
              position: absolute;
              left: 0;
              top: 0;
              width: 6px;
              height: 30px;
              background-color: #0078d7;
            }
            h4 {
              margin: 10px 0 10px 0;
            }
            p {
              margin: 0;
              padding: 0;
            }
          }
        }
        .appItemImg {
          flex: 1;
          padding: 10px 0;
          img {
            width: 610px;
            height: 540px;
            margin: 20px;
          }
        }
        .appItemCon {
          display: flex;
          width: 980px;
          margin: 0 auto;
        }
        .itemApp {
          flex: 1;
          padding: 0 20px;
          h3 {
            text-align: center;
          }
          .imgs {
            img {
              width: 100%;
            }
          }
        }
        .appItemList {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          .appItemListItem {
            flex: 1 1 25%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 30px;
            height: 170px;
            padding: 0 20px;
            background-color: rgba(242, 242, 242, 1);
          }
        }
      }
    }
  }
}
</style>
